module.exports = __webpack_public_path__ + "static/img/2024_yarlow_logo.54ec7f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/2024_yarlow_logo.png
// module id = nWRC
// module chunks = 1